import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HotelFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4 12.14v6.14h1.8v-2.84h12.4V18h1.803l-.013-3.55c-.015-3.888.001-3.634-.255-4.25a3.461 3.461 0 0 0-1.94-1.879c-.531-.197-.584-.2-3.685-.2L11.2 8.12v5.52H5.8V6H4v6.14m4.174-2.701c-.424.09-.845.438-1.042.861-.097.207-.112.29-.112.6 0 .311.015.394.113.604.143.309.452.617.767.764.207.097.29.112.6.112s.393-.015.6-.112c.315-.147.624-.455.767-.764.098-.21.113-.293.113-.604s-.015-.394-.113-.604a1.677 1.677 0 0 0-.748-.753 1.794 1.794 0 0 0-.945-.104" />
    </SvgIcon>
  );
});
